import S from 'pull-stream';
import _ from 'underscore';
import cat from 'pull-cat';
import async from 'pull-async';
import flatMerge from 'pull-flat-merge';
var r = {
    curry: require('ramda/src/curry'),
    prop: require('ramda/src/prop')
};
import Ev from '../../lib/event';

function fromCallback (onErr, onResp, fn) {
    if (!fn) {
        return function (fn) {
            return fromCallback(onErr, onResp, fn);
        };
    }

    return S(
        async(function (cb) {
            fn(function (err, resp) {
                if (err) return cb(null, onErr(err));
                cb(null, onResp(resp));
            });
        }),
        flatMerge()
    );
}

function sandwich (key, reqStream) {
    if (!reqStream) {
        return function (stream) {
            return sandwich(key, stream);
        };
    }

    return cat([
        S.once(Ev('start', { op: key })),
        reqStream,
        S.once(Ev('resolve', { op: key }))
    ]);
}

// fetch things
// take a key and an async function, return a stream
var request = r.curry(function (key, fn) {
    return _.compose(
        sandwich(key),
        fromCallback(
            _.compose(S.once, Ev('pushError')), // onErr
            _.compose(S.once, Ev(key), r.prop('data')) // onResp
        )
    )(fn);
});

request.sandwich = sandwich;
request.fromCallback = fromCallback;

export default request;
